import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ServicioAutorizaciones from "../../../servicios/Autorizaciones";
import ParametroRevocarAutorizacion from "../../../Contenedores/Autorizaciones/ParametroRevocarAutorizacion";
import { Notificar } from "../../Comunes/Notificador";
import DocumentosAutorizacionAdjuntar from "../../Comunes/Documentos/DocumentosAutorizacionAdjuntar";

function RevocarAutorizacionModal(props) {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [archivos, setArchivos] = useState([]);


  const handleClose = () => {

    setArchivos(null);
    setShow(false); 
  
  }

  const handleSubmit = async () => {
    const parametro = new ParametroRevocarAutorizacion();
    parametro.NumeroAutorizacion = props.datosAutorizacion.numeroAutorizacion;
    parametro.TipoAutorizacion =
      props.datosAutorizacion.tipoAutorizacion.codigo;
    parametro.Documentos = archivos;

    const resultado = await ServicioAutorizaciones.RevocarAutorizacion(
      parametro
    );

    if (!resultado.esValido) {
      Notificar("error", resultado.errores);
      return;
    }

    props.VolverAResultados(resultado.mensaje);
  };

  const obtenerDocumentos = (documentos) => {
    setArchivos(documentos);
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-warning btn-icon-split text-center ml-3"
        onClick={handleShow}
      >
        <span className="icon text-white-50">
          <i className="fas fa-user-times"></i>
        </span>
        <span className="text">Revocar</span>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        size="lg"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Revocar Autorización</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-4 pl-3 border-left-info">
            Por favor adjunte ambos lados de la identificación en un único
            archivo o en un archivo comprimido.
          </p>
          <DocumentosAutorizacionAdjuntar
            clasePersona={
              props.datosAutorizacion?.identificacion?.tipoPersona?.clase
            }
            onChangeDocumentos={obtenerDocumentos}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default RevocarAutorizacionModal;
